import React from 'react'

const RevenueRecords = () => {
  return (
    <div>RevenueRecords</div>
  )
}

export default RevenueRecords